/**
 * The sort directions a column heading's menu offers, worded for the column's data type per the
 * design: a numeric figure is not sorted "A – Z", and a name is not sorted "Low – High". There are
 * no date wordings — the table shows no date columns, and sorting by a hidden date would be
 * ambiguous.
 *
 * Ordering is part of the design too: text columns lead with ascending (A – Z), numeric columns
 * lead with DESCENDING (High – Low) — the biggest figures are what a numeric sort is usually
 * reached for. The dash is an en dash (–) with a space either side, everywhere.
 */
export interface SortMenuOption {
    direction: 'asc' | 'desc';
    label: string;
}

const TEXT_SORT_OPTIONS: SortMenuOption[] = [
    { direction: 'asc', label: 'A – Z' },
    { direction: 'desc', label: 'Z – A' },
];

const NUMERIC_SORT_OPTIONS: SortMenuOption[] = [
    { direction: 'desc', label: 'High – Low' },
    { direction: 'asc', label: 'Low – High' },
];

/** The two direction options for a column, worded and ordered by its data type. */
export function sortOptionsFor(numeric: boolean): SortMenuOption[] {
    return numeric ? NUMERIC_SORT_OPTIONS : TEXT_SORT_OPTIONS;
}
